export const getIndexFromSeat = (seatId) => seatId.replace('s', '')[0];

export const isNumber = (n) => !isNaN(parseFloat(n)) && isFinite(n);
